/**
 * Formatea un valor numérico o string con un sufijo. Retorna '-' si el valor es vacío/null/undefined.
 */
export const formatWithSuffix = (
  value: number | string | null | undefined,
  suffix: string,
): string => {
  if (value === undefined || value === null || value === '') {
    return '-';
  }

  return `${value} ${suffix}`;
};

/**
 * Formatea un booleano como 'Sí'/'No'. Retorna '-' si el valor es null/undefined.
 */
export const formatBoolean = (value?: boolean | null, yesLabel = 'Sí', noLabel = 'No'): string =>
  value === undefined || value === null ? '-' : value ? yesLabel : noLabel;
